import { configureStore } from '@reduxjs/toolkit'
import { EnumReduces } from './type';

import storeReducer from './features/store/reduce'
import productReducer from './features/product/reduce'

const middlewares: any[] = [];

if (process.env.NODE_ENV === `development` && typeof window !== "undefined") {
  const { logger } = require(`redux-logger`);
  middlewares.push(logger);
}

export const makeStore = () => {
  return configureStore({
    reducer: {
      [EnumReduces.STORE]: storeReducer,
      [EnumReduces.PRODUCT]: productReducer,
    },
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(middlewares),
  })
}

// Infer the type of makeStore
export type AppStore = ReturnType<typeof makeStore>
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<AppStore['getState']>
export type AppDispatch = AppStore['dispatch']